<template>
  <div>
    <Loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true" />

    <div v-if="!loading">
      <Questions />
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import Questions from '../components/Questions'

export default {
  name: 'questions',
  components: {
    Loading,
    Questions
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('setQuestionnaire')
      .then(result => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
</style>
